import { c as _c } from "react/compiler-runtime";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiXTdhGrant } from "@/generated/models/ApiXTdhGrant";
import { commonApiFetch } from "@/services/api/common-api";
interface UseXtdhGrantQueryParams {
  readonly grantId: string | null;
  readonly enabled?: boolean | undefined;
}
type UseXtdhGrantQueryResult = UseQueryResult<ApiXTdhGrant, Error> & {
  readonly grant: ApiXTdhGrant | undefined;
  readonly errorMessage?: string | undefined;
  readonly isEnabled: boolean;
};
const DEFAULT_STALE_TIME = 30_000; // 30 seconds

export function useXtdhGrantQuery(t0) {
  const $ = _c(11);
  const {
    grantId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const isEnabled = Boolean(grantId) && enabled;
  let t2;
  let t3;
  if ($[0] !== grantId) {
    t2 = [QueryKey.TDH_GRANTS, grantId];
    t3 = async () => {
      if (!grantId) {
        throw new Error("Grant ID is required");
      }
      return await commonApiFetch({
        endpoint: `xtdh/grants/${grantId}`
      });
    };
    $[0] = grantId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isEnabled || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      enabled: isEnabled,
      staleTime: DEFAULT_STALE_TIME
    };
    $[3] = isEnabled;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const query = useQuery(t4);
  const errorMessage = query.error instanceof Error ? query.error.message : undefined;
  let t5;
  if ($[7] !== errorMessage || $[8] !== isEnabled || $[9] !== query) {
    t5 = {
      ...query,
      grant: query.data,
      errorMessage,
      isEnabled
    };
    $[7] = errorMessage;
    $[8] = isEnabled;
    $[9] = query;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}